/** @format */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import utils from './../util';
import { apiPerfil } from '../api';
import Constantes from '../util/Constantes';
import alertify from 'alertifyjs';
import { Loader } from '../util/loader';

export const Mfa = () => {
  /* Begin By Javi */
  const [Loading, setloading] = useState(false);
  const [alertMessage, setMessage] = useState('Login UPN');
  /* End By Javi */
  const [MFAValue, setMFAValue] = useState({});
  const [dataUser, setdataUser] = useState(null);

  const handleInputChange = (e) => {
    const esValido = e.target.validity.valid;

    if (esValido) {
      setMFAValue({ ...MFAValue, [e.target.name]: e.target.value });
    }
  };

  const handleClickSalir = async () => {
    localStorage.removeItem('userLogin');
    localStorage.removeItem('studientActive');
    localStorage.removeItem('studientList');
    localStorage.removeItem('mfa');
    window.location.href = '/login';
  };

  useEffect(() => {
    const data = localStorage.getItem('userLogin');
    if (data) {
      setdataUser(JSON.parse(data));
    }
  }, []);

  if (!dataUser) {
    return <div>Loading...</div>;
  }

  const handleClickMFA = async () => {
    var userMFA = {
      username: dataUser.detail.login,
      mfa: MFAValue.codigo,
    };
    if (userMFA.mfa == '') {
      setloading(false);
      alertify.alert('Por favor ingrese el codigo !').setHeader(alertMessage);
      return;
    } else {
      const promise = apiPerfil.validarMFA(userMFA, alertMessage);
      promise.then((res) => {
        setloading(false);
        if (res != undefined) {
          if (res.detail != null && res.detail != '') {
            localStorage.setItem('mfa', res.detail.valido);
            window.location.href = '/home';
          }
        }
      });
    }
  };
  return (
    <section className='row'>
      {Loader(Loading)}
      <div id='branding' className='imgBx'></div>
      <div className='contentBx'>
        <div className='formBx'>
          <img src={Constantes().Imagen.LogoWeb} className='logoBx mb-2'></img>
          <h4 className='mb-5 mt-3'>
            Por favor ingrese el codigo enviado a su correo{' '}
            {dataUser.detail.email}
          </h4>
          <form>
            <div className='inputBx mb-3'>
              <input
                type='text'
                className='form-control'
                maxLength='10'
                placeholder='codigo'
                value={MFAValue.codigo}
                onChange={handleInputChange}
                name='codigo'
              />
            </div>
            <div className='row'>
              <div className='inputBx col-12'>
                <input
                  type='button'
                  className='btnSubmit'
                  value='Ingresar'
                  onClick={handleClickMFA}
                />
              </div>
            </div>
            <div className='row'>
              <div className='inputBx col-12'>
                <input
                  type='button'
                  className='btnRegresar'
                  value='Regresar'
                  onClick={handleClickSalir}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};
